<div
  class="flex w-full py-3.5 items-center px-6 bg-navy title font-main text-3xl font-bold text-navy-90 border-b border-navy-30"
>
  {{ buildTranslationKey('header') | translate }}
</div>

<div *ngVar="profiles$ | async as profiles" class="w-full h-full overflow-x-hidden overflow-y-auto pt-4 pb-2 px-6">
  <div class="flex w-full h-full flex-col gap-4 max-w-125">
    <div class="flex w-full flex-col gap-1">
      <div class="text-navy-90 font-bold text-base">
        {{ buildTranslationKey('subheader') | translate }}
      </div>

      <div class="text-navy-70 text-base flex flex-col">
        {{ buildTranslationKey('description') | translate }}
      </div>
    </div>

    <div class="flex items-center gap-4">
      <app-new-button [svgIconPath]="'Add'" [size]="'responsive'" (click)="openAddProfileModal()">
        {{ buildTranslationKey('newProfileBtn') | translate }}
      </app-new-button>

      <div class="w-px h-full bg-navy-40"></div>

      <app-data-search
        class="profile-search flex-1"
        [placeholderTranslationKey]="buildTranslationKey('search')"
        [data]="profiles"
        [searchDefinitions]="searchDefinitions"
        [routeParamsDisabled]="true"
        [disabled]="!profiles?.length"
        (search)="handleSearch($event)"
      ></app-data-search>
    </div>

    <div class="h-px w-full bg-navy-40"></div>

    @if (displayedData$ | async; as displayedData) {
      <div class="flex flex-col flex-1 gap-y-2 overflow-y-auto">
        <div class="profiles-container">
          @for (profile of displayedData; track profile.id) {
            <app-profile-item [profileId]="profile.id"></app-profile-item>
          }
        </div>
      </div>
    }
  </div>
</div>
